// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1816":"4d6b1e618289a039","2609":"b2be2b33c95d77b0","6152":"ddb666414ab4ffce"}[chunkId] + ".css";
};